import { type ParameterID } from '@flecto/types'

export function isValidParameterID(id?: ParameterID) {
  return Boolean(id) && Number.isSafeInteger(Number(id))
}
